<lex-action-panel panelHeight="full" class="fontify-13px">
    <div action-title>Export Document to Briefcase</div>
    <div action-body>
        <div style="display: flex; flex-direction: column; padding: 20px; gap: 8px; ">
            <div style="margin-bottom: 12px; display: flex; gap: 12px; flex-direction: column;">
                <lex-text-input label="Title" placeholder="Enter Briefcase title" [(ngModel)]="briefcase.title"></lex-text-input>
                    <lex-text-input label="Comments" placeholder="Enter comment" type="textarea"
                    [(ngModel)]="briefcase.comments"></lex-text-input>
                <div class="form-container">
                    <label for="titleType">Filenames</label>
                    <mat-select matNativeControl id="titleType" class="fontify-13px" style="height: 32px; border: 1px solid #565656;
                                    border-radius: 5px; display: flex; align-items: center;" [(ngModel)]="briefcase.titleType">
                        <mat-option value="0" class="fontify-13px">Using Doc Titles</mat-option>
                        <mat-option value="1" class="fontify-13px">Using Bates Numbers</mat-option>
                        <mat-option value="2" class="fontify-13px">Using Control Numbers</mat-option>
                        <mat-option value="3" class="fontify-13px">Using Master Dates</mat-option>
                        <mat-option value="4" class="fontify-13px">Using Original Doc Titles</mat-option>
                        <mat-option value="5" class="fontify-13px">Using Doc Ids</mat-option>
                    </mat-select>
                </div>
                <lex-text-input label="Control Number Prefix" placeholder="Enter control number prefix"
                   [(ngModel)]="briefcase.controlNumberBasePrefix"></lex-text-input>
                <lex-text-input label="Custom Designation" placeholder="Enter custom designation"
                                [(ngModel)]="briefcase.customDesignation"></lex-text-input>
            </div>
            <div style="margin-bottom: 12px;">
                <div class="container">
                    <mat-checkbox matInput [(ngModel)]="briefcase.expandToEmailFamily">Expand to Email Family</mat-checkbox>
                </div>
            </div>
            <div style="margin-bottom: 12px;">
                <span class="area-header">Stamp on PDF Pages:</span>
                <div style="margin-top: 8px;">
                    <div class="container" style="margin-bottom: 6px;">
                        <mat-checkbox matInput [(ngModel)]="briefcase.isDocIdStampPages">Document Ids</mat-checkbox>
                    </div>
                    <div class="container" style="margin-bottom: 6px;">
                        <mat-checkbox matInput [(ngModel)]="briefcase.isControlNumberStampPages">Existing Control Numbers
                        </mat-checkbox>
                    </div>
                    <div class="container">
                        <mat-checkbox matInput [(ngModel)]="briefcase.isBatesStampPages">Existing Bates Numbers</mat-checkbox>
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 12px;">
                <span class="area-header">Output Options:</span>
                <div style="margin-top: 8px;">
                    <div class="container" style="margin-bottom: 6px;">
                        <mat-checkbox matInput [(ngModel)]="briefcase.includeMergedPdfs">Merge into a single PDF file</mat-checkbox>
                    </div>
                    <div class="container" style="margin-bottom: 6px;">
                        <mat-checkbox matInput [(ngModel)]="briefcase.allowSharing">Allow others to access this
                            Briefcase</mat-checkbox>
                    </div>
                    <div class="container">
                        <mat-checkbox matInput [(ngModel)]="briefcase.sendNotification">Notify me on
                            Completion</mat-checkbox>
                    </div>
                </div>
            </div>
            <div>
                <lex-flat-button (click)="ok()" label="Create Briefcase" [icon]="'fa-duotone fa-check-double'"></lex-flat-button>
            </div>
        </div>
    </div>
</lex-action-panel>
